import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Button, Menu } from "@mui/material";
import { ProjectsDropdown } from "../components";
import { IonCol } from "@ionic/react";
import { CiMenuFries } from "react-icons/ci";

export const NavMenu = (props) => {
  const { projectOptions, navItems, project } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <IonCol className="menu-col">
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <CiMenuFries className="nav-menu-icon" />
      </Button>
      <Menu
        className="menu-dropdown"
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <IonCol className="nav-item-container transparent-frame">
          <div>
            <ProjectsDropdown
              handleClose={handleClose}
              projectOptions={projectOptions}
            />
          </div>
          <div style={{ paddingTop: "4rem" }}>
            <ul>
              {navItems.map((item, index) => (
                <NavLink
                  key={index}
                  className="nav-item-menu"
                  to={item?.path}
                  end={item?.path === `/${project}`}
                  style={({ isActive }) => ({
                    color: isActive ? "#3ad246" : null,
                  })}
                >
                  <span onClick={handleClose}>{item?.label.toUpperCase()}</span>
                </NavLink>
              ))}
            </ul>
          </div>
        </IonCol>
      </Menu>
    </IonCol>
  );
};
